import { globalObservability } from '@opendoor/observability/slim';

const Sentry = globalObservability.getSentryClient();

/**
 * Reports a handled error to Sentry, tagged with the operation that failed so
 * the failures are easy to group/search. Use for caught errors that are
 * recovered from (e.g. a query that falls back to an empty list).
 */
export const captureError = (error: unknown, op: string): void => {
  Sentry.withScope?.((scope) => {
    scope.setTag('op', op);
    Sentry.captureException?.(error);
  });
};
